import { isValidElement, useCallback, useEffect, useState } from 'react';
import { MessageDescriptor } from 'react-intl';
import Toggle from '../Toggle/Toggle';

import styles from './OptionalField.module.scss';

type OptionalFieldProps<T> = {
	name: string;
	id: string;
	label: MessageDescriptor | React.ReactNode;
	initialState?: boolean;
	onChange: (value: T | null) => void;
	children(options: { onChange: (value: T | null) => void }): React.ReactNode;
};

const OptionalField = <T,>({
	id,
	name,
	label,
	initialState = false,
	onChange,
	children,
	...rest
}: OptionalFieldProps<T>) => {
	const [enabled, setEnabled] = useState(initialState);
	const setValue = useCallback(
		(value: T | null) => {
			onChange(value);
		},
		[onChange]
	);

	useEffect(() => {
		if (!enabled) setValue(null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [enabled]);

	return (
		<div className={styles.container} {...rest}>
			<Toggle
				className={styles.toggle}
				checked={enabled}
				name={name}
				id={id}
				label={(!isValidElement(label) && (label as MessageDescriptor)) || undefined}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEnabled(e.target.checked)}
			>
				{isValidElement(label) && label}
			</Toggle>
			{enabled && <div className={styles.field}>{children({ onChange: setValue })}</div>}
		</div>
	);
};

export default OptionalField;
